import { render } from "./ExamNewOffcanvas.vue?vue&type=template&id=e4a165a6&scoped=true"
import script from "./ExamNewOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamNewOffcanvas.vue?vue&type=script&lang=js"

import "./ExamNewOffcanvas.vue?vue&type=style&index=0&id=e4a165a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a165a6"]])

export default __exports__